import * as React from 'react';
import { SVGProps } from 'react';

const SvgCopyOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 17v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-2Zm2-12H9v2h6a2 2 0 0 1 2 2v6h2V5ZM5 9h10v10H5V9Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgCopyOutlined;
